import { render, staticRenderFns } from "./UCProductPrice.vue?vue&type=template&id=e0c0d0be&scoped=true&"
import script from "./UCProductPrice.vue?vue&type=script&lang=ts&"
export * from "./UCProductPrice.vue?vue&type=script&lang=ts&"
import style0 from "./UCProductPrice.vue?vue&type=style&index=0&id=e0c0d0be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0c0d0be",
  null
  
)

export default component.exports